<template>
  <div
    :class="withIcon ? 'col-12 col-sm-4' : 'col-xs-12 col-sm-6 col-lg-3'"
  >
    <div class="form-group">
      <div class="custom-dropdown">
        <button
          class="form-control dropdown-toggle text-left capital"
          type="button"
          id="capital"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false">
            <slot></slot>
            Capital Type
            <i class="icon icon-arrow-down-custom icon-right"></i>
        </button>
        <div class="dropdown-menu" aria-labelledby="capital">
          <ul>
            <li v-for="capitalType in capitalTypes">
              <span class="custom-control custom-checkbox rtl">
                <input
                  type="checkbox"
                  name="capital[]"
                  class="custom-control-input"
                  :id="capitalType.name"
                  :checked="selected(capitalType)"
                  v-on:click="toggleSearch(capitalType)"
                >
                  <label class="custom-control-label" :for="capitalType.name">
                    {{capitalType.name}}
                    <sup class="text-primary lead help">
                      <!-- <strong
                        data-toggle="tooltip"
                        data-placement="top"
                        title="Nulla non ipsum in enim condimentum viverra nec ac sem. Suspendisse convallis molestie nulla in consectetur. In porttitor risus id risus congue, nec accumsan urna pharetra.">
                          ?
                      </strong> -->
                    </sup>
                  </label>
                </input>
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { mapGetters, mapActions, mapMutations } from "vuex";

export default {
  name: "capital-type-dropdown",
  props: ['withIcon', 'type'],
  computed: {
    ...mapGetters({
      results: "results",
      capitalTypes: "capitalTypes",
      capitalTypeSelected: 'capitalTypeSelected',
      providerTypeSelected: 'providerTypeSelected',
      countrySelected: 'countrySelected',
      sectorSelected: 'sectorSelected',
      dataCapitalTypeSelected: 'dataCapitalTypeSelected'
    }),
  },
  methods: {
    ...mapMutations([
      'toggleSectorsParam',
      'toggleCapitalTypesParam',
      'toggleProviderTypesParam',
      'toggleCountriesParam',
      'setSelectedDataCapitalTypes'
    ]),
    selected: function(value){
      if (this.type=='chart') {
        return this.dataCapitalTypeSelected(value)
      } else {
        return this.capitalTypeSelected(value)
      }
    },
    ...mapActions(['search']),
    toggleSearch(value){
      if (this.type == 'chart') {
        this.setSelectedDataCapitalTypes(value)
      } else {
        this.toggleCapitalTypesParam(value)
      }
      this.$emit('user-select')
      $('.dropdown-menu').click(function(e) {
        e.stopPropagation();
      });
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/elements/SearchBars/dropdowns/CapitalTypeDropDown.vue